import { createAction, props } from '@ngrx/store';

import {
    ICallableParams,
    IDataCurrentOrders,
    IDataEcommerceConfig,
    IProductos,
    IPromosEcommerce,
    IRespOrder,
    IRespProductos,
    IResultCancelaPedidos,
    IResultProductPromo,
    IResultPromosEcommerce,
    IResultSendCart,
    IResultSendOrder,
    IResultSendWebhook,
    ISendWebhookParams,
    PedidoActualEntity,
    PedidoHistoricoEntity,
} from '../../private/shared/models/productos';
import { IRequestEndpoint } from '../../shared/models/request.model';
import { CartProductsState } from '../reducers/ecommerce.reducer';

/**
 * Obtiene los productos disponibles del usuario
 */
export const getProducts = createAction(
    '[GetProducts] Get Products',
    props<ICallableParams>()
);

export const successGetProducts = createAction(
    '[GetProducts] Get Products Success',
    props<IRespProductos>()
);

export const errorGetProducts = createAction(
    '[GetProducts] Get Products Error',
    props<{ payload: Error }>()
);

export const resetProducts = createAction('[GetProducts] Reset Products list');

export const addProductsCartState = createAction(
    '[GetProducts] add products the cart state',
    props<{ cartProducto: IProductos[] }>()
);

export const addProductCartState = createAction(
    '[GetProducts] add products count the cart state',
    props<{ id_producto: number, productSelect: number }>()
);

/**
 * Cart State
 */
export const addingProductsToCartState = createAction(
    '[CartState] adding products to cart state',
    props<CartProductsState>()
);

export const addCartState = createAction(
    '[CartState] add products the cart state',
    props<{ cartProducto: IProductos, productsSelect: number }>()
);

export const removeCartState = createAction(
    '[CartState] remove products the cart state',
    props<{ id_producto: number }>()
);

export const addingPromosToCartState = createAction(
    '[CartPromoState] Adding promos to cart state',
    props<{ cartPromos: Array<IProductos> }>()
);

export const addCartPromoState = createAction(
    '[CartPromoState] Add promo the cart state',
    props<{ promo: IPromosEcommerce, cartPromos: Array<IProductos>, promoSelect: number }>()
);

export const removeCartPromoState = createAction(
    '[CartPromoState] Remove promo the cart state',
    props<{ ClavePromo: string }>()
);

export const clearCartProducts = createAction('[CartState] Clear Cart Products');

/**
 * Resume detail order
 */
export const addingProductsToResumeState = createAction(
    '[DetailOrderState] adding products to resume state',
    props<CartProductsState>()
);
export const clearDetailOrder = createAction('[DetailOrderState] Clear Resume Order');

/**
 * Promociones ecommerce
 */

export const getPromosEcommerce = createAction(
    '[PromoState] Get Promos Ecommerce'
);

export const successPromosEcommerce = createAction(
    '[PromoState] Success PromosEcommerce',
    props<IResultPromosEcommerce>()
);

export const errorPromosEcommerce = createAction(
    '[PromoState] Error Promos Ecommerce',
    props<{ payload: Error }>()
);

export const resetPromosEcommerce = createAction('[PromoState] Clear Promos Ecommerce');

export const activePromosEcommerce = createAction(
    '[PromoState] Validates if the module is active',
    props<{ PromoModulo: boolean }>()
);

/**
 * Productos de promociones ecommerce
 */
export const getProductPromo = createAction(
    '[ProductPromo] Get Product Promo',
    props<ICallableParams>()
);
export const successProductPromo = createAction(
    '[ProductPromo] Success Product Promo',
    props<IResultProductPromo>()
);

export const editPromo = createAction(
    '[ProductPromo] Edit Promo Cart',
    props<{ ClavePromo: string }>()
);

export const resetEditPromo = createAction(
    '[ProductPromo] Reset Edit Promo Cart'
);


/**
 * Guardado del Carrito
 */

export const sendCart = createAction(
    '[SendCart] Send Cart state'
);

export const successSendCart = createAction(
    '[SendCart] Success Send Cart',
    props<IResultSendCart>()
);

export const errorSendCart = createAction(
    '[SendCart] Error Send Cart',
    props<{ payload: Error }>()
);

export const resetSendCart = createAction('[SendCart] Clear Send Cart');

/**
 * Envio del pedido
 */

export const sendOrderState = createAction(
    '[SendOrder] Send order state',
    props<ICallableParams>()
);

export const successSendOrder = createAction(
    '[SendOrder] Success Send Order',
    props<IResultSendOrder>()
);

export const errorSendOrder = createAction(
    '[SendOrder] Error Send Order',
    props<{ payload: Error }>()
);

export const detailOrder = createAction(
    '[SendOrder] Detail Order',
    props<{ endpoint: IRequestEndpoint, respOrder: PedidoActualEntity | PedidoHistoricoEntity | IRespOrder }>()
);

export const successDetailOrder = createAction(
    '[SendOrder] Success Detail Order',
    props<{ respOrder: IRespOrder }>()
);

export const errorDetailOrder = createAction(
    '[SendOrder] Error Detail Order',
    props<{ payload: Error }>()
);

export const resetSendOrder = createAction('[SendOrder] Clear Send Order');

/**
 * Obtiene Pedidos
 */

export const sendObtienePedidos = createAction('[ObtienePedidos] Obtiene Pedidos state');

export const successObtienePedidos = createAction(
    '[ObtienePedidos] Success Obtiene Pedidos',
    props<{ data: IDataCurrentOrders }>()
);

export const errorObtienePedidos = createAction(
    '[ObtienePedidos] Error Obtiene Pedidos',
    props<{ payload: Error }>()
);

export const resetObtienePedidos = createAction('[ObtienePedidos] Clear Obtiene Pedidos');

/**
 * Cancela Pedidos
 */

export const sendCancelaPedidos = createAction(
    '[CancelaPedidos] Cancela Pedidos state',
    props<ICallableParams>()
);

export const successCancelaPedidos = createAction(
    '[CancelaPedidos] Success Cancela Pedidos',
    props<IResultCancelaPedidos>()
);

export const errorCancelaPedidos = createAction(
    '[CancelaPedidos] Error Cancela Pedidos',
    props<{ payload: Error }>()
);

export const resetCancelaPedidos = createAction('[CancelaPedidos] Clear Cancela Pedidos');

/**
 * Set ID_Pedido
 */
export const setIDPedido = createAction(
    '[SetIDPedido] Set ID_Pedido',
    props<{ pedidoActual: PedidoActualEntity; fecha_entrega: string; }>()
);
/**
 * Set clearCart, si debe o no limpiar el state
 */
export const setClearCart = createAction(
    '[SetIDPedido] Set clearCart',
    props<{ clearCart: boolean; }>()
);

/**
 * Manda informaión al Webhook
 */
export const sendWebhook = createAction(
    '[SendWebhook] Send Webhook',
    props<ISendWebhookParams>()
);

export const successSendWebhook = createAction(
    '[SendWebhook] Send Webhook Success',
    props<IResultSendWebhook>()
);

export const errorSendWebhook = createAction(
    '[SendWebhook] Send Webhook Error',
    props<{ payload: Error }>()
);

export const resetSendWebhook = createAction('[SendWebhook] Clear Send Webhook');

/**
 * Ecommerce Config
 */

export const sendEcommerceConfig = createAction('[EcommerceConfig] Send Ecommerce Config');

export const successEcommerceConfig = createAction(
    '[EcommerceConfig] Success Ecommerce Config',
    props<{ data: IDataEcommerceConfig }>()
);

export const errorEcommerceConfig = createAction(
    '[EcommerceConfig] Error Ecommerce Config',
    props<{ payload: Error }>()
);

export const resetEcommerceConfig = createAction('[EcommerceConfig] Clear Ecommerce Config');

